import { render, staticRenderFns } from "./constructionsTable2.vue?vue&type=template&id=2d0f1295&scoped=true"
import script from "./constructionsTable2.vue?vue&type=script&lang=js"
export * from "./constructionsTable2.vue?vue&type=script&lang=js"
import style0 from "./constructionsTable2.vue?vue&type=style&index=0&id=2d0f1295&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0f1295",
  null
  
)

export default component.exports